import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
const NAMES = ['María G.', 'Roberto F.', 'Laura M.', 'Esteban R.', 'Patricia C.', 'Juan P.', 'Ana S.', 'Carlos D.', 'Sofía L.', 'Miguel A.', 'Lucía B.', 'Diego M.', 'Valentina R.', 'Martín G.', 'Julieta P.'];
const LOCATIONS = ['Córdoba, Argentina', 'Rosario, Argentina', 'La Plata, Argentina', 'Mendoza, Argentina', 'Mar del Plata, Argentina', 'Buenos Aires, Argentina', 'Santa Fe, Argentina', 'Tucumán, Argentina', 'Salta, Argentina', 'Madrid, España', 'Barcelona, España', 'Valencia, España'];
const PRODUCTS = ['SIC 360', 'Pack Full 360', 'Megapack Comercial'];
export function PurchaseNotification() {
  const [isVisible, setIsVisible] = useState(false);
  const [notification, setNotification] = useState({
    name: '',
    location: '',
    product: ''
  });
  useEffect(() => {
    // Initial delay
    const initialTimeout = setTimeout(() => {
      showNotification();
    }, 5000);
    const showNotification = () => {
      const name = NAMES[Math.floor(Math.random() * NAMES.length)];
      const location = LOCATIONS[Math.floor(Math.random() * LOCATIONS.length)];
      const product = PRODUCTS[Math.floor(Math.random() * PRODUCTS.length)];
      setNotification({
        name,
        location,
        product
      });
      setIsVisible(true);
      // Hide after 5 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
      // Schedule next notification (random between 8-15 seconds after hiding)
      const nextDelay = Math.floor(Math.random() * (15000 - 8000 + 1) + 8000) + 5000;
      setTimeout(showNotification, nextDelay);
    };
    return () => clearTimeout(initialTimeout);
  }, []);
  return <AnimatePresence data-id="element-346">
      {isVisible && <motion.div initial={{
      x: 100,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: 100,
      opacity: 0
    }} className="fixed bottom-4 right-4 z-50 max-w-sm w-full bg-white rounded-lg shadow-lg border border-gray-100 p-4 flex items-center gap-3" data-id="element-347">
          <div className="bg-green-100 p-2 rounded-full flex-shrink-0" data-id="element-348">
            <CheckCircle className="w-5 h-5 text-green-600" data-id="element-349" />
          </div>
          <div data-id="element-350">
            <p className="text-sm font-medium text-gray-900" data-id="element-351">
              <span className="font-bold" data-id="element-352">{notification.name}</span> de{' '}
              {notification.location}
            </p>
            <p className="text-xs text-gray-500" data-id="element-353">
              Compró{' '}
              <span className="font-semibold text-blue-600" data-id="element-354">
                {notification.product}
              </span>{' '}
              hace unos instantes
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}